<template>
    <div v-if="param.isShow">
        <div class="popup-dimmed on" />
        <div class="popup-wrapper alert on">
            <div class="popup-container">
                <div class="popup-body">
                    <p style="color: #fff;">
                        {{ param.msg }}
                    </p>
                </div>

                <div class="popup-bottom">
                    <div class="btn-wrapper">
                        <button class="btn btn-cancel" @click="close()">
                            <span>취소</span>
                        </button>
                        <button class="btn btn-confirm" @click="ok(param.callback)">
                            <span>확인</span>
                        </button>
                    </div>
                </div>
            </div>
            <button class="popup-close" @click="close()">
                <span class="blind">닫기</span>
            </button>
        </div>
    </div>
    <!-- // loading -->
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
    name: 'Confirm',
    components: {},
    props: {
        param: {
            type: Object
        }
    },
    data: () => {
        return {};
    },
    watch: {
        param: {
            // the callback will be called immediately after the start of the observation
            immediate: true,
            deep: true,
            handler(val) {
                this.param = val;
            }
        }
    },
    computed: {
        ...mapState({})
    },
    beforeCreate() {},
    created() {},
    mounted() {},
    beforeDestroy() {},
    methods: {
        ...mapActions([]),
        close() {
            this.param.isShow = false;
        },
        ok(callbackParam) {
            this.param.isShow = false;
            this.$emit('confirmCallback', this.param.callbackParam);
        }
    }
};
</script>
